<div class="modal-header add-activity-modal-header">
  <div>
    <h5 class="modal-title mb-0">
      <i class="fas fa-calendar-plus mr-2"></i>
      {{ getModalStepTitle() }}
    </h5>
    @if (!reqId) {
      <small class="text-muted d-block mt-1 modal-step-indicator">
        Paso {{ currentStep }} de 3
      </small>
    }
  </div>
  <button type="button" class="close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<form (ngSubmit)="submitActivity()">
  <div class="modal-body modal-body-scrollable">
    @if (!reqId && currentStep > 1) {
      <div class="breadcrumb-navigation mb-3">
        <button type="button" class="btn btn-link p-0" (click)="goBack()">
          <i class="fas fa-arrow-left mr-2"></i>
          Volver
        </button>
        @if (selectedRequirementTypeId) {
          <div class="selected-type-panel mt-2">
            <span class="selected-type-label">Tipo seleccionado</span>
            <div class="selected-type-value">
              {{ getSelectedRequirementTypeName() }}
            </div>
          </div>
        }
      </div>
    }

    <!-- PASO 2: Tipo de Requerimiento -->
    @if (!reqId && currentStep === 2) {
      <div class="form-group">
        <label class="text-form">
          Tipo de Requerimiento <span class="text-danger">*</span>
        </label>
        @if (loadingTypes) {
          <div class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <small class="d-block mt-2 text-muted">Cargando tipos...</small>
          </div>
        }

        @if (!loadingTypes) {
          <ng-select
            class="form-control px-0 py-0"
            [items]="filteredRequirementTypes"
            bindValue="id"
            bindLabel="fullname"
            [searchable]="true"
            [clearable]="true"
            [appendTo]="'body'"
            placeholder="Seleccionar tipo de requerimiento..."
            [(ngModel)]="selectedRequirementTypeId"
            name="requirementTypeSelect"
            (change)="selectedRequirementTypeId ? selectRequirementType(selectedRequirementTypeId) : null"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item?.fullname || item?.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div>
                <strong>{{ item?.name }}</strong>
                @if (item?.fullname && item.fullname !== item.name) {
                  <small class="d-block text-muted">{{ item.fullname }}</small>
                }
              </div>
            </ng-template>
          </ng-select>
        }
      </div>
    }

    <!-- PASO 3: Requerimiento -->
    @if (!reqId && currentStep === 3) {
      <div class="step-requirement-picker">
        @if (!selectedRequirementId) {
          <div class="grid-search-block mb-3">
            <div class="grid-search-context mb-2">
              <span>Búsqueda en:</span>
              <span class="font-weight-bold ml-2">{{ getSelectedRequirementTypeName() }}</span>
            </div>
            <div class="input-wrapper">
              <input
                type="search"
                class="form-control input-box filter grid-style-search"
                placeholder="ID, abogado, solicitante..."
                [(ngModel)]="searchRequirementText"
                (ngModelChange)="onSearchRequirementChange($event)"
                name="searchRequirement"
                >
              <svg xmlns="http://www.w3.org/2000/svg" class="input-icon search" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
              </svg>
            </div>
          </div>
        }

        @if (getSelectedRequirement(); as selected) {
          <div class="selected-requirement-card mb-3">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <span class="selected-req-label">Requerimiento seleccionado</span>
                <div class="selected-req-id">#{{ selected.id }}</div>
                <div class="selected-req-name">{{ selected.name }}</div>
                @if (selected.status || selected.stagestatus) {
                  <div class="selected-req-meta status-meta">
                    <i class="fas fa-flag status-icon-soft mr-1"></i>
                    {{ selected.stagestatus || selected.status }}
                  </div>
                }
                @if (selected.creator) {
                  <div class="selected-req-meta">
                    <span class="req-party-label">Solicitante:</span>
                    <span class="req-party-value">{{ selected.creator }}</span>
                  </div>
                }
                @if (selected.owner) {
                  <div class="selected-req-meta">
                    <span class="req-party-label">Responsable:</span>
                    <span class="req-party-value">{{ selected.owner }}</span>
                  </div>
                }
              </div>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearRequirementSelection()">
                Cambiar
              </button>
            </div>
          </div>
        }

        @if (loadingRequirements) {
          <div class="text-center py-4">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <small class="d-block mt-2 text-muted">Cargando requerimientos...</small>
          </div>
        }

        @if (!loadingRequirements && !selectedRequirementId) {
          @if (requirementsTotal > 0) {
            <p class="results-summary text-muted mb-2">
              Mostrando {{ filteredRequirements.length }} de {{ requirementsTotal }} requerimientos
              @if (requirementsHasMore) {
                <span> — use la búsqueda o cargue más resultados</span>
              }
            </p>
          }
          <div class="requirements-list">
            @for (requirement of filteredRequirements; track requirement.id) {
              <button
                type="button"
                class="requirement-item"
                (click)="selectRequirement(requirement.id)"
                >
                <div class="requirement-icon">
                  <span class="requirement-id-pill">#{{ requirement.id }}</span>
                </div>
                <div class="requirement-info">
                  <div class="requirement-name">{{ requirement.name }}</div>
                  @if (requirement.status || requirement.stagestatus) {
                    <div class="requirement-meta status-meta">
                      <i class="fas fa-flag status-icon-soft mr-1"></i>
                      <span>{{ requirement.stagestatus || requirement.status }}</span>
                    </div>
                  }
                  <div class="requirement-meta requirement-parties">
                    @if (requirement.creator) {
                      <span class="req-party">
                        <span class="req-party-label">Solicitante:</span>
                        <span class="req-party-value">{{ requirement.creator }}</span>
                      </span>
                    }
                    @if (requirement.owner) {
                      <span class="req-party">
                        <span class="req-party-label">Responsable:</span>
                        <span class="req-party-value">{{ requirement.owner }}</span>
                      </span>
                    }
                  </div>
                  <div class="requirement-meta text-muted requirement-date">
                    <i class="far fa-calendar-alt mr-1"></i>{{ formatDate(requirement.date) }}
                  </div>
                </div>
                <div class="requirement-arrow">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </button>
            }
            @if (filteredRequirements.length === 0) {
              <div class="no-results text-center py-4">
                <i class="fas fa-inbox fa-2x text-muted mb-2"></i>
                <p class="text-muted mb-0">
                  @if (searchRequirementText) {
                    No hay resultados para "{{ searchRequirementText }}"
                  } @else {
                    No hay requerimientos para este tipo
                  }
                </p>
              </div>
            }
          </div>
          @if (requirementsHasMore && filteredRequirements.length > 0) {
            <button
              type="button"
              class="btn btn-outline-primary btn-block mt-3"
              [disabled]="loadingRequirements"
              (click)="loadMoreRequirements()"
              >
              Cargar más requerimientos
            </button>
          }
        }
      </div>
    }

    <!-- PASO 1: Formulario -->
    @if (reqId || currentStep === 1) {
    <!-- Sección Actividad -->
    <div class="section-header mb-3 mt-2">
      <h5 class="section-title">
        <i class="fas fa-user mr-2"></i>
        Actividad
      </h5>
    </div>

    <!-- Asunto -->
    <div class="form-group">
      <label class="text-form">
        Asunto <span class="text-danger">*</span>
      </label>
      <input
        type="text"
        class="form-control"
        name="asunto"
        [(ngModel)]="newActivity.subject"
        (ngModelChange)="updateCalendarLinks()"
        placeholder=""
        >
    </div>

    <!-- Texto -->
    <div class="form-group">
      <label class="text-form">Texto</label>
      <textarea
        class="form-control"
        name="texto"
        rows="3"
        [(ngModel)]="newActivity.content"
        (ngModelChange)="updateCalendarLinks()"
        placeholder=""
      ></textarea>
    </div>

    <!-- Fecha y Hora -->
    <div class="form-group">
      <div class="row">
        <div class="col-md-6">
          <label class="text-form">
            Fecha: <span class="text-danger">*</span>
          </label>
        </div>
        <div class="col-md-6">
          <label class="text-form">
            Hora: <span class="text-danger">*</span>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Seleccionar fecha"
              name="fecha"
              [(ngModel)]="dateActv"
              readonly
            >
            <div class="input-group-append">
              <span class="input-group-text">
                <i class="fas fa-calendar"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <input
            type="time"
            class="form-control time-input"
            [(ngModel)]="activityTime"
            (ngModelChange)="updateCalendarLinks()"
            name="time_actv"
            placeholder="00:00"
            >
        </div>
      </div>
    </div>
    <!-- Colaboradores -->
    <div class="form-group">
      <label class="text-form">Colaboradores</label>
      <ng-select
        [(ngModel)]="multipleMultiSelect"
        [items]="collaborators"
        bindLabel="text"
        bindValue="id"
        [multiple]="true"
        [appendTo]="'body'"
        placeholder="Seleccione colaboradores"
        name="colaboradores"
        class="form-control px-0 py-0"
        >
      </ng-select>
    </div>

    <!-- Sección Alertas -->
    <div class="section-header mb-3 mt-4">
      <h5 class="section-title">
        <i class="fas fa-bell mr-2"></i>
        Alertas
      </h5>
    </div>

    <div class="alerts-section">
      <button
        type="button"
        class="btn btn-success btn-add-alert"
        (click)="addAlert()"
        >
        <i class="fas fa-plus"></i>
      </button>

      <!-- Formularios de alertas -->
      @for (alert of alertsList; track alert; let i = $index) {
        <div class="alert-form-item mt-3">
          <div class="row">
            <div class="col-md-5">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="Seleccionar fecha"
                  [(ngModel)]="alertDates[i]"
                  [name]="'alert_date_' + i"
                  ngbDatepicker
                  [attr.id]="'alertDatepicker' + i"
                  #alertDatepicker="ngbDatepicker"
                  [minDate]="mindate"
                  [maxDate]="maxdate"
                  [readonly]="true"
                  placement="top-left"
                  [container]="'body'"
                  (ngModelChange)="onAlertDateChange(i, $event)"
                  >
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-secondary"
                    (click)="alertDatepicker.toggle()"
                    type="button"
                    >
                    <i class="fas fa-calendar-alt"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <input
                type="time"
                class="form-control time-input"
                [(ngModel)]="alertTimes[i]"
                [name]="'alert_time_' + i"
                (ngModelChange)="onAlertTimeChange(i, $event)"
                placeholder="00:00"
                >
            </div>
            <div class="col-md-2 text-center">
              <button
                type="button"
                class="btn btn-danger btn-remove-alert"
                (click)="removeAlert(i)"
                >
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Mensajes -->
    @if (successMessage) {
      <div class="form-group">
        <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
      </div>
    }
    @if (errorMessage) {
      <div class="form-group">
        <ngb-alert class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
      </div>
    }
    }
  </div>

  <div class="modal-footer">
    <!-- Paso 1: continuar / crear -->
    @if (!reqId && currentStep === 1) {
      <div class="action-buttons ml-auto">
        <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Cerrar</button>
        <button type="button" class="btn btn-success" (click)="continueFromForm()">Continuar</button>
      </div>
    }

    <!-- Paso 2: cerrar (seleccionar tipo avanza a paso 3) -->
    @if (!reqId && currentStep === 2) {
      <div class="action-buttons ml-auto">
        <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Cerrar</button>
      </div>
    }

    <!-- Paso 3 (o reqId predefinido): footer final -->
    @if (reqId || currentStep === 3) {
      <div class="calendar-icons-container">
        <span class="calendar-icons-label">También crear en:</span>
        <a
          [href]="linkGoogle"
          target="_blank"
          class="calendar-icon-link"
          (click)="updateCalendarLinks()"
          title="Crear en Google Calendar"
          >
          <img src="assets/img/icons/google-calendar.svg" width="24" height="24" alt="Google Calendar" />
        </a>
        <a
          [href]="linkOutlook"
          target="_blank"
          class="calendar-icon-link"
          (click)="updateCalendarLinks()"
          title="Crear en Outlook"
          >
          <img src="assets/img/icons/outlook-icon.svg" width="24" height="24" alt="Outlook" />
        </a>
      </div>
      <div class="action-buttons">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="activeModal.close('Close click')"
          >
          Cerrar
        </button>
        <button
          type="submit"
          class="btn btn-success"
          [disabled]="loading || (!reqId && currentStep === 3 && !selectedRequirementId)"
          >
          @if (loading) {
            <span>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Guardando...
            </span>
          }
          @if (!loading) {
            <span>
              Crear
            </span>
          }
        </button>
      </div>
    }
  </div>
</form>


